import styled from 'styled-components';

const Spacer = styled.div`
  display: flex;
  min-height: 80vh;
`;

export default Spacer;
